import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import Axios from 'axios';
// Plugins Vuex
import VuexORM, { Database } from '@vuex-orm/core';
import VuejsStorage from 'vuejs-storage';
// Models
import MasterAttitude from './planner/purpose/Attitude';
import MasterPreLearning from './planner/purpose/PreLearning';
import MasterSkill from './planner/purpose/Skill';
import User from './commons/User';
import School from './commons/School';
import Oa from './planner/objetive/Oa';
import Ie from './planner/objetive/Ie';
import DuaCategory from './planner/activity/DuaCategory';
import Dua from './planner/activity/Dua';
// Models Unit plan
import UnitPlan from './units/UnitPlan';
import UnitPlanOa from './planner/objetive/UnitPlanOa';
import UnitPlanWeek from './planner/coverage/UnitPlanWeek';
import UnitPlanWeekIe from './planner/coverage/UnitPlanWeekIe';
// Model unit plan purpose
import UnitPlanPreLearning from './planner/purpose/UnitPlanPreLearning';
import UnitPlanSkill from './planner/purpose/UnitPlanSkill';
import UnitPlanAttitude from './planner/purpose/UnitPlanAttitude';
// Models unit plan activities
import UnitPlanActivity from './planner/activity/UnitPlanActivity';
import UnitPlanActivityFile from './planner/activity/UnitPlanActivityFile';
import UnitPlanActivityIe from './planner/activity/UnitPlanActivityIe';
import UnitPlanActivityDua from './planner/activity/UnitPlanActivityDua';
// Default language by vuetify
import Vuetify from '../plugins/Vuetify';
import groupAutocompleteList from '../commons/groupAutocompleteList';
import UnitPlanComments from './units/UnitPlanComments';

import { IState } from '../interfaces/IState';
// @ts-ignore
import { UnitList } from './legacy/UnitList';
import { IUnitPlanPaginator } from '../interfaces/units/IUnitPlanPaginator';
import { IUnitPlanFilter } from '../interfaces/units/IUnitPlanFilter';

import _ from "lodash";

Vue.use(Vuex);

// instanciando la base de datos
const database: Database = new VuexORM.Database();

// Registrando modelos en la base de datos
// MAESTROS
database.register(MasterAttitude);
database.register(MasterPreLearning);
database.register(MasterSkill);
// OTROS
database.register(User);
database.register(School);
database.register(UnitPlan);
database.register(UnitPlanOa);
database.register(UnitPlanComments);
database.register(Oa);
database.register(Ie);
database.register(UnitPlanPreLearning);
database.register(UnitPlanSkill);
database.register(UnitPlanAttitude);
database.register(DuaCategory);
database.register(Dua);
database.register(UnitPlanActivity);
database.register(UnitPlanActivityFile);
database.register(UnitPlanActivityIe);
database.register(UnitPlanActivityDua);
database.register(UnitPlanWeek);
database.register(UnitPlanWeekIe);

// Configuración básicas axios
Axios.defaults.baseURL = process.env.VUE_APP_ROMA_PLANNER_API_URL;
Axios.defaults.timeout = 1000 * 60 * 20;
// axios.defaults.timeout = 1000*60*5;
Axios.defaults.responseType = 'json';

// Orlandadas
Axios.defaults.withCredentials = true;
Axios.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error.message === 'Network Error') {
        window.location.replace(process.env.VUE_APP_ROMA_PLANNER_API_URL+'/logout');
    } else if (error.code === 'ECONNABORTED') {
        if (!vuex.state.snackbar.show) {
            vuex.state.snackbar = {
                show: true,
                text: 'El tiempo de espera para la petición ha sido excedido',
                color: 'red',
                timeout: 0,
            };
        }
        return {
            data: {
                status: {
                    code: 0,
                },
            },
        };
    }
    return Promise.reject(error.response);
});

// const processMessage = (error) => {
//   const msg: any = {
//     show: !vuex.state.snackbar.show,
//     color: 'red',
//     text: '',
//     timeout: 0,
//   };
//   if (!!error.response) {
//     const data = error.response.data;
//     switch (data.status.code) {
//       case 3:
//         if (Array.isArray(data.content)) {
//           return Promise.reject(data.content.message);
//         } else {
//           msg.text = data.content.message;
//           vuex.state.snackbar = msg;
//         }
//         break;
//       default:
//         break;
//     }
//   } else {
//     msg.text = 'Falta parámetros requeridos en la petición';
//     vuex.state.snackbar = msg;
//   }
// };

// axios.interceptors.response.use((response: AxiosResponse) => {
//   return response.data.content;
// }, (error) => {
//   console.error('Error en petición', error);
//   switch (error.status) {
//     case 400:
//       processMessage(error);
//       break;
//       case 500:
//       processMessage(error);
//       break;
//     default:
//       if (error.message === 'Network Error') {
//         // window.location.replace('https://dev.romaevalua.cl');
//       } else if (error.code === 'ECONNABORTED') {
//         vuex.state.snackbar = {
//           show: !vuex.state.snackbar.show,
//           text: 'El tiempo de espera para la petición ha sido excedido',
//           color: 'red',
//           timeout: 0,
//         };
//       }
//       break;
//   }
// });


const vuex = new Vuex.Store<IState>({
    state: {
        logoURL: 'https://plataforma.romacl.com/LogoInstitucion?id=',
        baseURL: Axios.defaults.baseURL,
        user: {
            role: 'teacher',
        },
        appLoading: false,
        updatePlanAnual: false,
        config: {
            selectedLanguage: Vuetify.preset.lang.current,
        },
        languages: [
            // Iconos tomados de: https://www.flaticon.com/packs/countrys-flags
            { title: 'Español', i18n: 'es', icon: '#' },
            { title: 'Ingles', i18n: 'en', icon: '#' },
        ],
        snackbar: {
            show: false,
            timeout: 15000,
            color: 'info',
            text: '',
        },
        highlight: '',
        roma: [],
        romaForFilters: {},
        unitList: {
            paginator: {
                page: 1,
                lastPage: 0,
                totalItems: 0,
                itemsPerPage: 10,
                filter: {
                    institution: -1,
                    plan: -1,
                    subject: -1,
                    level: -1,
                    course: -1,
                    unit: -1,
                    editionStatus: -1,
                    planStatus: -1,
                    teacher: -1,
                    percentage: -1,
                    isActive: true,
                    pie: false,
                    years: -1,
                    yearsArray: []
                } as IUnitPlanFilter,
            } as IUnitPlanPaginator,
        } as UnitList,
        organizer: {
            selectedSchool: {},
            selectedPeriod: new Date().getFullYear(),
        },
        info: {
            contact: {
                phone: '+569 3458 0660',
                sac: '229293270',
                email: 'sac@romacl.com',
                location: {
                    lat: '10.2099343',
                    lon: '-68.0119684,12z',
                },
            },
            social: [
                {
                    icon: 'instagram',
                    url: 'http://instagram.com/',
                },
                {
                    icon: 'facebook',
                    url: 'http://facebook.com/',
                },
                {
                    icon: 'youtube',
                    url: 'http://youtube.com/',
                },
            ],
        },
    } as IState | unknown,
    mutations: {
        setDefaultFilters(state: IState) {
            state.unitList.paginator.filter = {
                institution: -1,
                plan: -1,
                subject: -1,
                level: -1,
                course: -1,
                courseName: '',
                unit: -1,
                editionStatus: -1,
                planStatus: -1,
                teacher: -1,
                percentage: -1,
                isActive: true,
                pie: false,
                puName: "",
                years: -1,
            };
        },
        setUser(state: IState, data) {
            data.isUTP = data.roles.some((rol: string) => rol === 'AdministradorAcademico');
            state.user = data;
        },
        setRoma(state: IState, data) {
            data.forPlanUnidad.forEach((subject: any) => {
                const newLevel: any = [];
                
                subject.niveles = subject.niveles.map((nivel) => {
                    nivel.nombre = nivel.nombre.replace('ENSEÑANZA', 'EDUCACIÓN');
                    return nivel;
                });
                subject.niveles = _.orderBy(subject.niveles, 'nombre');
                
                const eduAdultos = subject.niveles.find((nivel) => {
                    return nivel.nombre == 'EDUCACIÓN ADULTOS'
                });

                if(eduAdultos){
                    subject.niveles = subject.niveles.filter((nivel) => nivel.nombre != 'EDUCACIÓN ADULTOS');
                    subject.niveles.push(eduAdultos);
                }

                subject.niveles.forEach((educacion: any) => {
                    newLevel.push({ header: educacion.nombre });
                    // tslint:disable-next-line:max-line-length
                    educacion.categorias = _.orderBy(educacion.categorias, 'orden');

                    educacion.categorias.forEach((categoria: any) => newLevel.push({ id: categoria.id, name: categoria.nombre, cursos: categoria.cursos }));
                });
                subject.niveles = newLevel;
            });
            state.roma = data;
        },
        appLoading(state, status: boolean = true) {
            state.appLoading = status;
        },
        planAnualList(state, status: Array<Object> = []) {
            state.planAnualList = status;
        },
        highlightWords(state, words) {
            state.highlight = words;
        },
        selectLanguage(state, language: object) {
            Vuetify.framework.lang.current = language; // Cambia lenguaje de vuetify
            state.config.selectedLanguage = language;
        },
        // School
        selectSchool(state, school: object) {
            state.organizer.selectedSchool = school;
        },
        toggleUtp(state, isUtp: boolean) {
            if (isUtp) {
                state.user.role = 'utp';
            } else {
                state.user.role = 'teacher';
            }
        },
        setFilters(state, data) {
            const dataForFilters = Object.assign({}, data);
            dataForFilters.educacionList = groupAutocompleteList(dataForFilters.educacionList, 'categorias');
            state.romaForFilters = dataForFilters;
        },
    },
    actions: {
        async getFileFromUrl({ commit }, url) {
            let response = null;
            try {
                response = await Axios.get(url, { responseType: 'blob' });
            } catch (errors) {
                response = errors;
            }
            return response;
        },
        async updateActivityOrders({ commit }, request) {
            let response = null;
            try {
                response = await Axios.post('actividad/updateOrder', request);
            } catch (errors) {
                response = errors;
            }
            return response;
        },
        async getUnitPlans({ commit }, request) {
            let response = null;
            try {
                response = await Axios.get('planUnidad/list', { params: request });
            } catch (errors) {
                response = errors;
            }
            return response;
        },
        async getAnualPlans({commit}, request) {
            let response = null;
            try{
                response = await Axios.get('planUnidad/list/plan-anual', { params: request })
            } catch (errors) {
                response = errors;
            }
            return response;
        },
        async getYearsFromInstitution({ commit }, request) {
            let response = null;
            try {
                response = await Axios.get('planUnidad/list/years', { params: request });
            } catch (errors) {
                response = errors;
            }
            return response;
        },
        async getSectionWithSubjects({ commit }, request) {
            let response = null;
            try {
                response = await Axios.get(`commons/secciones/periodo/${request}`);
            } catch (errors) {
                response = errors;
            }
            return response;
        },
        async getEducations({ commit }, request) {
            let response = null;
            try {
                response = await Axios.get('commons/getEducation');
            } catch (errors) {
                response = errors;
            }
            return response;
        },
        async getReport({ commit }, request) {
            let response = null;
            try {
                response = await Axios.get('reports/getReport', request);
            } catch (errors) {
                response = errors;
            }
            return response;
        },
        async saveComment({ commit }, request) {
            let response = null;
            try {
                response = await Axios.post('planUnidadComentario/create', request);
            } catch (errors) {
                response = errors;
            }
            return response;
        },
        async downloadFile({ commit }, file: UnitPlanActivityFile) {
            let response = null;
            try {
                // @ts-ignore
                response = await Axios.get('actividad/file/' + file.id);
            } catch (errors) {
                response = errors;
            }
            return response;
        },
        async saveHours({ commit }, hoursToSave) {
            let response = null;
            try {
                response = await Axios.post('planUnidadOA/saveHours/', hoursToSave);
            } catch (errors) {
                response = errors;
            }
            return response;
        },
        async deletePlanUnit({ commit }, idPlanUniad) {
            let response = null;
            try {
                response = await Axios.delete('planUnidad/delete/' + idPlanUniad);
            } catch (errors) {
                response = errors;
            }
            return response;
        },
        async activatePlanUnit({ commit }, idPlanUniad) {
            let response = null;
            try {
                response = await Axios.put('planUnidad/activate/' + idPlanUniad);
            } catch (errors) {
                response = errors;
            }
            return response;
        },
        async setUnitPlanStatus({ commit }, request) {
            let response = null;
            const { idPlanUnidad, commands } = request;
            try {
                response = await Axios.patch('planUnidad/setEstado/' + idPlanUnidad, commands);
            } catch (errors) {
                response = errors;
            }
            return response;
        },
        async userData({ commit }) {
            try {
                const response = await Axios.get('user/data');

                commit('setUser', response.data.content);

                const school = {
                    id: response.data.content.institution.id,
                    cod: response.data.content.institution.cod,
                    name: response.data.content.institution.name,
                    logo: response.data.content.institution.identificationCode,
                    yearSelected: response.data.content.institution.yearSelected,
                };
                School.insertOrUpdate({ data: school });
                commit('setDefaultFilters');
                // tslint:disable-next-line:max-line-length
                this.state.unitList.paginator.filter.institution = response.data.content.privileges.canFilterByInstitution ? -1 : school.id;
                commit('selectSchool', School.find(school.id));
            } catch (errors) {
                console.log(errors);
            }
        },
        async roma({ commit }, request) {
            try {
                if (this.state.user.isUTP || this.state.user.privileges.canCudPlanAndClose) {
                    const response = await Axios.get('planUnidad/informationToCreate', request);
                    
                    commit('setRoma', response.data.content);
                }
            } catch (errors) {
                console.log(errors);
            }
            return;
        },
        async createUnitPlan({ commit }, request) {
            let response = null;
            try {
                response = await Axios.post('planUnidad/save', request);
            } catch (errors) {
                response = errors;
            }
            return response;
        },
        async toggleUnitPlanOA({ commit }, request) {
            let response = null;
            try {
                response = await Axios.post('planUnidadOA/toggleAll', request);
            } catch (errors) {
                response = errors;
            }
            return response;
        },
        async addUnitPlanOAComplement({ commit }, request) {
            let response = null;
            try {
                response = await Axios.post('planUnidadOA/addToPlanUnidad', request);
            } catch (errors) {
                response = errors;
                console.error('Error al añadir objetivos', errors);
            }
            return response;
        },
        async uploadExcels({ commit }, request) {
            let response = null;
            try {
                const data = new FormData();
                data.append('file', request.file);
                response = await Axios.post('import/file/?tipo=' + request.tipo, data);
            } catch (errors) {
                response = errors;
            }

            return response;
        },
        async romaOAsBySubjectId({ commit }, request) {
            let response = null;
            try {
                response = await Axios.get('oa/list', { params: request });
            } catch (errors) {
                response = errors;
            }

            return response;
        },
        async getUnitPlanWeeks({ commit }, request) {
            let response = null;
            try {
                response = await Axios.get('planUnidadSemana/getAll/?idPlanUnidad=' + request);
            } catch (errors) {
                response = errors;
            }

            return response;
        },
        async setUnitPlanWeeks({ commit }, request) {
            let response = null;
            try {
                response = await Axios.post('planUnidadSemanaItem/saveMany', request);
            } catch (errors) {
                response = errors;
            }

            return response;
        },
        async setUnitPlanWeeksAdvance({ commit }, request) {
            let response = null;
            try {
                response = await Axios.post('/planUnidadSemanaItem/registerAdvance', request);
            } catch (errors) {
                response = errors;
            }

            return response;
        },
        async romaForFilter({ commit }) {
            let response = null;
            try {
                response = await Axios.get('planUnidad/informationToFilter');
                if (response && response.data && response.data.status && response.data.status.code === 1
                    && response.data.content.estados && response.data.content.estados.length > 0) {
                    response.data.content.estados.splice(
                        0,
                        0,
                        { description: 'En Planificación', disabled: true },
                    );
                    response.data.content.estados.splice(
                        8,
                        0,
                        { description: 'En Replanificación', disabled: true },
                    );
                    response.data.content.estados = response.data.content.estados
                        .map((status: any) => {
                            if (status.text || !status.description.includes(':')) { return status; }
                            status.description = status.description
                                .substring(status.description.lastIndexOf(':') + 1).trim();
                            return status;
                        });
                }
                commit('setFilters', response.data.content);
            } catch (errors) {
                response = errors;
            }

            return response;
        },
        async getUnitPlanActivity({ commit }, request) {
            let response = null;
            try {
                response = await Axios.get('actividad/' + request);
            } catch (errors) {
                response = errors;
            }
            return response;
        },
        async getUnitPlanActivities({ commit }, request) {
            let response = null;
            try {
                response = await Axios.get('actividad/listByPlanUnidad/' + request);
            } catch (errors) {
                response = errors;
            }

            return response;
        },
        async getUnitPlanPurpose({ commit }, request) {
            let response = null;
            try {
                response = await Axios.get('planUnidad/purpose/' + request);
            } catch (errors) {
                response = errors;
            }

            return response;
        },
        async getUnitPlanPreLearnings({ commit }, request) {
            let response = null;
            try {
                response = await Axios.get('planUnidadConocimiento/list', { params: request });
            } catch (errors) {

            }

            return response;
        },
        async setUnitPlanPreLearning({ commit }, request) {
            let response = null;
            try {
                response = await Axios.post('planUnidadConocimiento/save', request);
            } catch (errors) {
                response = errors;
            }

            return response;
        },
        async getSkills({ commit }, request) {
            let response = null;
            try {
                response = await Axios.get('aprendizajeNivel/list/', request);
            } catch (errors) {
                response = errors;
            }

            return response;
        },
        async setSkills({ commit }, request) {
            let response = null;
            try {
                response = await Axios.post('aprendizajeNivel/save', request);
            } catch (errors) {
                response = errors;
            }

            return response;
        },
        async getAttitudes({ commit }, request) {
            let response = null;
            try {
                response = await Axios.get('actitud/list', request);
            } catch (errors) {
                response = errors;
            }

            return response;
        },
        async setAttitudes({ commit }, request) {
            let response = null;
            try {
                response = await Axios.post('actitud/save', request);
            } catch (errors) {
                response = errors;
            }

            return response;
        },
        async setUnitPlanPurpose({ commit }, request) {
            let response = null;
            try {
                response = await Axios.post('planUnidad/savePurpose', request);
            } catch (errors) {
                response = errors;
            }

            return response;
        },
        async setUnitPlanActivity({ commit }, request) {
            let response = null;
            try {
                response = await Axios.post('actividad/save', request);
            } catch (errors) {
                response = errors;
            }

            return response;
        },
        async delUnitPlanActivity({ commit }, request) {
            let response = null;
            try {
                response = await Axios.delete('actividad/delete/' + request);
            } catch (errors) {
                response = errors;
            }

            return response;
        },
        async setUnitPlanActivityFiles({ commit }, request) {
            let response = null;
            try {
                const data = new FormData();
                if (request.files && request.files.length > 0) {
                    request.files.forEach((file: File) => {
                        data.append('files', file);
                    });
                }
                response = await Axios.post('actividad/files/' + request.id + '/' + request.entityType + '/' + request.entityId, data);
            } catch (errors) {
                response = errors;
                throw response;
            }

            return response;
        },
        async getEvaluationTypes({ commit }) {
            let response = null;
            try {
                response = await Axios.get('tipoEvaluacion/list');
            } catch (errors) {
                response = errors;
            }

            return response;
        },
        async getInstrumentTypes({ commit }) {
            let response = null;
            try {
                response = await Axios.get('tipoInstrumentoEvaluacion/list');
            } catch (errors) {
                response = errors;
            }

            return response;
        },
        async getDuas({ commit }, request) {
            let response = null;
            try {
                response = await Axios.get('dua/list', request);
            } catch (errors) {
                response = errors;
            }
            return response;
        },
        async getCategoriesAndSubjects({ commit }) {
            let response = null;
            let subjects: any[] = [];
            let educationList: any[] = [];
            try {
                response = await Axios.get('/commons/getCategoriesAndSubjects');
                subjects = response.data.content.asignaturas;
                educationList = groupAutocompleteList(response.data.content.educacionList, 'categorias');
            } catch (errors) {
                response = errors;
            }
            return { subjects, educationList };
        },
    },
    plugins: [
        VuexORM.install(database),
        // @ts-ignore
        VuejsStorage({
            keys: [
                // Webapp Configs
                'user',
                'config',
                'languages',
                // User Selecteds
                'organizer',
                'unitList',
                // ORM
                'entities.unit_plans',
                'entities.unitplan_oas',
                'entities.comments',
                'entities.unit_plan_attitudes',
                'entities.unit_plan_prelearnings',
                'entities.unit_plan_skills',
                'entities.master_attitudes',
                'entities.master_prelearnings',
                'entities.master_skills',
                'entities.unitplan_activities',
                'entities.unitplan_activity_duas',
                'entities.unitplan_activity_files',
                'entities.unitplan_activity_ies',
                'entities.unitplan_weeks',
                'entities.unitplan_week_ies',
                // Reports
                'dataToReport',
            ],
            namespace: 'roma',
            // @ts-ignore
            driver: VuejsStorage.drivers.localStorage,
        }),
    ],
} as StoreOptions<IState>);

export default vuex;

// Seed datos
Axios.get('/user/data')
    .then((response) => {
        if (response.data.content.roles.length <= 0) {
            alert('No se encontraron roles para el usuario');
            window.location.replace(process.env.VUE_APP_ROMA_PLANNER_API_URL+'/logout');
            // @ts-ignore
        } else if (Object.values(response.data.content.privileges).every((privilege: boolean) => !privilege)) {
            alert('El usuario no tiene privilegios');
            window.location.replace(process.env.VUE_APP_ROMA_PLANNER_API_URL+'/logout');
        }
        vuex.commit('setUser', response.data.content);
        const school = {
            id: response.data.content.institution.id,
            cod: response.data.content.institution.cod,
            name: response.data.content.institution.name,
            logo: response.data.content.institution.identificationCode,
            yearSelected: response.data.content.institution.yearSelected,
        };
        School.insertOrUpdate({ data: school });
        // @ts-ignore
        if (vuex.state.organizer.selectedSchool.id !== school.id) { vuex.commit('setDefaultFilters'); }
        // tslint:disable-next-line:max-line-length
        vuex.state.unitList.paginator.filter.institution = response.data.content.privileges.canFilterByInstitution ? -1 : school.id;
        vuex.commit('selectSchool', School.find(school.id));
    })
    .catch((error) => {
        console.log('Error al colocar data de usuario', error);
    });
